import { empty, isValidPhoneNumber, sendGAEvent } from '../../../Shared/Assets/utils';
import EventBus, { EventName } from '../../../Shared/Assets/event-bus';
import UserDataService from "../../../Shared/Assets/userdata-service";

export default class VerifyPhoneNumber {
  constructor() {
    this._handleFormSubmit = this._handleFormSubmit.bind(this);
    this._showError = this._showError.bind(this);
    this._validateForm = this._validateForm.bind(this);
    this._handleSuccessResponse = this._handleSuccessResponse.bind(this);
    this._handleErrorResponse = this._handleErrorResponse.bind(this);

    this.eventBus = new EventBus();
  }

  init(formElement) {
    this.form = formElement;
    if (this.form.getAttribute('data-init') === "1") return false;
    this.form.setAttribute('data-init', "1");

    this.form.addEventListener('submit', this._handleFormSubmit);
    this.btnVerify = this.form.btnVerify;
    this.$validationField = $(this.form).find('.error-message');

    return true;
  }

  _handleFormSubmit(evt) {
    evt.preventDefault();

    if (!this._validateForm()) {
      return false;
    }

    let thisForm = this.form;
    let actionUrl = thisForm.action;
    let dataParams = {
      NetworkId: thisForm.NetworkId.value,
      PhoneNumber: thisForm.PhoneNumber.value
    };

    this._showLoading();

    $.ajax({
      url: actionUrl,
      type: 'POST',
      data: dataParams,
      success: this._handleSuccessResponse,
      error: this._handleErrorResponse
    });

    return false;
  }

  _validateForm() {
    if (empty(this.form.NetworkId.value)) {
      this._showError("There is an issue with the form. Please try again later.");
      return false;
    }
    if (empty(this.form.PhoneNumber.value)) {
      this._showError("Phone number required");
      return false;
    }
    else if (!isValidPhoneNumber(this.form.PhoneNumber.value)) {
      this._showError("Valid phone number required");
      return false;
    }

    return true;
  }

  _showLoading() {
    this.btnVerify.classList.add('loading');
    this.btnVerify.disabled = true;
  }

  _hideLoading() {
    this.btnVerify.classList.remove('loading');
    this.btnVerify.disabled = false;
  }

  _handleSuccessResponse(result) {
    this._hideLoading();

    if (!empty(result.htmlContent)) {
      $('.seller-verification')
        .empty()
        .append(result.htmlContent);

      if (result.shouldInitVerifyCodeForm) {
        this.eventBus.dispatch(EventName.InitVerifyCodeForm);
      }

      if (!empty(result.userData)) {
        let userDataService = new UserDataService();
        userDataService.saveData(result.userData);
      }
    }
    else {
      this._showGeneralError();
    }
    
    this._fireTracking(result.trackingData);
  }

  _handleErrorResponse(error) {
    this._hideLoading();

    if (empty(error.responseJSON)) {
      this._showGeneralError();
      return;
    }

    if (!empty(error.responseJSON.message)) {
      this._showError(error.responseJSON.message);
    }

    this._fireTracking(error.responseJSON.trackingData);
  }

  _showError(message) {
    this.$validationField.text(message);
  }

  _showGeneralError() {
    this.$validationField.text("We are experiencing difficulties verifying your number. Please try again later.");
  }

  _fireTracking(tracking) {
    if (!empty(tracking) && !empty(tracking.label)) {
      sendGAEvent(tracking.category, tracking.label, tracking.action);
    }
  }
}